export function switcher() {
  const language = document.querySelectorAll('.js-switcher');
  const windowWidth = window.innerWidth;
  const windowSm = 768;

  for (let languages of language) {

    // PCホバー時
    languages.addEventListener('mouseover', function () {
      this.classList.add("is-active");
    });
    languages.addEventListener('mouseleave', function () {
      this.classList.remove("is-active");
    });

    // スマホクリックー時
    if (windowWidth <= windowSm) {
      languages.addEventListener('click', function () {
        this.classList.toggle("is-active");
      });
    }
  }
}